import $ from 'jquery'

export function initCustomChip(chip) {
  $(document).on(`turbolinks:load.customchip${chip}`, function () {
    const root = $(`.custom-chip-generator[data-chip="${chip}"]`);
    if (!root.length) return;

    const profile = JSON.parse(root.attr('data-profile'));
    const form = root.closest('.order-form').find('form').has('#partNumber').first();
    const partNumber = form.find('#partNumber');
    const submit = form.find('#btnRequest');
    const reset = form.find('#btnReset');

    function fieldInput(key) {
      return root.find(`[data-config-key="${key}"]`);
    }

    function updateDisabledFields() {
      const selectedDisableFunction = fieldInput('disableFunction').filter(':checked').val();
      const disabledFields = (profile.disabled_frequencies || {})[selectedDisableFunction] || [];
      profile.fields.forEach(function (field) {
        if (field.type !== 'number') return;
        const input = fieldInput(field.key);
        const disabled = disabledFields.includes(field.key);
        input.prop('disabled', disabled);
        if (disabled) input.val('');
      });
    }

    function normalizeNumber(field, clamp) {
      const input = fieldInput(field.key);
      let value = input.val().replace(/[^0-9.]/g, '');
      const parts = value.split('.');
      value = parts[0];
      if (field.key !== 'tuningSlope' && parts.length > 1) {
        let decimals = parts.slice(1).join('');
        if (field.max_decimal_places !== undefined) decimals = decimals.slice(0, field.max_decimal_places);
        value += '.' + decimals;
      }
      value = value.slice(0, 8);
      const format = fieldInput('signalFormat').filter(':checked').val();
      const max = field.key === 'frequency' && (profile.cmos_formats || []).includes(format)
        ? profile.cmos_frequency_max
        : field.max;
      input.attr('max', max);
      if (clamp && value !== '') {
        if (value === '.') value = '';
        else if (Number(value) < field.min) value = String(field.min);
        else if (Number(value) > max) value = String(max);
        else if (value.endsWith('.')) value = value.slice(0, -1);
      }
      input.val(value);
      return value;
    }

    function validNumber(field, value) {
      if (!/^(?:\d+(?:\.\d*)?|\.\d+)$/.test(value)) return false;
      const decimalPlaces = field.max_decimal_places;
      const decimals = value.split('.')[1];
      if (decimalPlaces !== undefined && ((decimalPlaces === 0 && decimals !== undefined) || (decimals && decimals.length > decimalPlaces))) return false;

      const number = Number(value);
      if (!Number.isFinite(number) || number < field.min || number > Number(fieldInput(field.key).attr('max'))) return false;

      const step = Number(field.step);
      if (!Number.isFinite(step)) return true;
      const stepCount = (number - field.min) / step;
      return Math.abs(stepCount - Math.round(stepCount)) < 0.000001;
    }

    function update(event) {
      updateDisabledFields();

      const payload = Object.assign({ chip: chip }, profile.fixed);
      let valid = true;
      profile.fields.forEach(function (field) {
        if (!field.key) return;

        const input = fieldInput(field.key);
        if (field.type === 'radio') {
          const selected = input.filter(':checked').val();
          if (selected === undefined) valid = false;
          else payload[field.key] = selected;
        } else if (input.prop('disabled')) {
          payload[field.key] = '1';
        } else {
          const value = normalizeNumber(field, !event || event.type !== 'input');
          if (!validNumber(field, value)) valid = false;
          if (field.payload_scale) {
            payload[field.key] = String(Number((Number(value) * field.payload_scale).toFixed(8)));
          } else {
            payload[field.key] = value;
          }
        }
      });

      const direction = fieldInput('sscType').filter(':checked').val();
      const amplitude = fieldInput('sscAmpPeak').val();
      const positiveAmplitude = !direction || !amplitude ? '' : direction === 'center' ? amplitude : '0';
      root.find('[data-ssc-amp-positive]').val(positiveAmplitude);
      root.find('[data-ssc-amp-positive-sign]').toggleClass('d-none', !positiveAmplitude || Number(positiveAmplitude) === 0);

      partNumber.val(valid ? JSON.stringify(payload) : '');
      submit.prop('disabled', !valid);
      return valid;
    }

    root.off('.customchip').on('input.customchip change.customchip', '[data-config-key]', update);
    form.off('.customchip').on('submit.customchip', function (event) {
      if (!update()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });
    reset.off('.customchip').on('click.customchip', function (event) {
      event.preventDefault();
      profile.fields.forEach(function (field) {
        if (!field.key) return;
        const input = fieldInput(field.key);
        if (field.type === 'radio') {
          input.prop('checked', false);
          if (field.label === 'temperature') input.first().prop('checked', true);
        } else if (field.type === 'number') {
          input.val('');
        }
      });
      update();
    });

    update();
  });
}
